import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "w-4 mr-3",
  role: "img",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 448 512"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("path", {
  fill: "#B82025",
  d: "M400 480H48c-26.51 0-48-21.49-48-48V80c0-26.51 21.49-48 48-48h352c26.51 0 48 21.49 48 48v352c0 26.51-21.49 48-48 48zm-204.686-98.059l184-184c6.248-6.248 6.248-16.379 0-22.627l-22.627-22.627c-6.248-6.248-16.379-6.249-22.628 0L184 302.745l-70.059-70.059c-6.248-6.248-16.379-6.248-22.628 0l-22.627 22.627c-6.248 6.248-6.248 16.379 0 22.627l104 104c6.249 6.25 16.379 6.25 22.628.001z"
}, null, -1)
const _hoisted_3 = {
  key: 1,
  class: "w-4 mr-3",
  role: "img",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 448 512"
}
const _hoisted_4 = /*#__PURE__*/_createVNode("path", {
  fill: "#e0e0e0",
  d: "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-6 400H54c-3.3 0-6-2.7-6-6V86c0-3.3 2.7-6 6-6h340c3.3 0 6 2.7 6 6v340c0 3.3-2.7 6-6 6z"
}, null, -1)
const _hoisted_5 = { class: "text-12px xxl:text-14px text-black-lp-300 hover:text-red-lp-100" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", {
    class: 
      `cursor-pointer flex flex-row items-center py-1 ${_ctx.index === _ctx.length - 1 &&
        'pb-2'} ${_ctx.isSelected(_ctx.item) ? 'text-red-lp-2400' : 'text-black-lp-200'}`
    ,
    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onChooseSelect(_ctx.item)))
  }, [
    (_ctx.isSelected(_ctx.item))
      ? (_openBlock(), _createBlock("svg", _hoisted_1, [
          _hoisted_2
        ]))
      : (_openBlock(), _createBlock("svg", _hoisted_3, [
          _hoisted_4
        ])),
    _createVNode("span", _hoisted_5, _toDisplayString(_ctx.item[_ctx.keyName] || _ctx.item), 1)
  ], 2))
}